/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_No_Venue_MatchesInputs */

const cs_settings_venues_no_venue_matches = /** @type {(inputs: Settings_Venues_No_Venue_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná pobočka tomu hledání neodpovídá.`)
};

const en_settings_venues_no_venue_matches = /** @type {(inputs: Settings_Venues_No_Venue_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No venues match that search.`)
};

/**
* | output |
* | --- |
* | "No venues match that search." |
*
* @param {Settings_Venues_No_Venue_MatchesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_no_venue_matches = /** @type {((inputs?: Settings_Venues_No_Venue_MatchesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_No_Venue_MatchesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_no_venue_matches(inputs)
	return cs_settings_venues_no_venue_matches(inputs)
});